import { Flex, Button, Text, useDisclosure } from "@chakra-ui/react";

import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { ModalDelete } from "@root/components/modal-delete";

interface IDeleteSelectedButtonProps {
  onRemoveClick: () => void;
  selectedChatCount: number;
  isDisabled: boolean;
}

export const DeleteSelectedButton: React.FC<IDeleteSelectedButtonProps> = ({
  onRemoveClick,
  selectedChatCount,
  isDisabled,
}) => {
  const { t } = useTranslation("common") || { t: (key: string) => key };

  const { isOpen, onOpen, onClose } = useDisclosure(); // Chakra UI modal control

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    onOpen();
  };

  const handleDelete = () => {
    onRemoveClick();
    onClose();
  };

  return (
    <Flex justifyContent="center" alignItems="center">
      <Button
        width={"120px"}
        height={"32px"}
        backgroundColor={"purple.500"}
        borderRadius={"8px"}
        onClick={handleClick}
        isDisabled={isDisabled}
        variant="outline"
      >
        <Text fontSize="12px" textColor={"white"} fontWeight={500}>
          {t("chat.deleteSelected")}
        </Text>
      </Button>

      <ModalDelete
        isOpen={isOpen}
        onClose={onClose}
        onConfirm={handleDelete}
        title={t("chat.deleteChat")}
        chatCountDescription={t("chat.areYouSureCount", { selectedChatCount })}
        deleteButtonTitle={t("chat.deleteBtn")}
        cancelButtonTitle={t("chat.cancelBtn")}
      />
    </Flex>
  );
};
